<template>
  <div style="width: 100%; height: 100%;">
    <fin-onboarding-get-started v-if="startScreen"
                                :exist-process="currentState>0"
                                mode="onboarding"
                                @continue="continueProcess"
                                @restart="restart"/>
    <div v-else>
      <fin-onboarding-slider v-if="onboardingMode"
                             :navigation-label="showLabels"
                             :nonEditable="editablePageIndex"
                             @cancel="cancel"
                             style="position: fixed; top: 0; z-index: 2;"
                             v-model="currentState"/>

      <fin-onboarding-step2 v-if="currentState===1"
                            v-model="model.step1"
                            :origin="origin"
                            @dirty="resetNextSteps2and3"
                            @nextStep="goToStep2()"
                            @pageChange=" page => this.showLabels=page===0"/>

      <fin-onboarding-step3 v-else-if="currentState===2"
                            v-model="model.step2"
                            @nextStep="goToStep3()"
                            @pageChange=" page => this.showLabels=page===0"/>

      <fin-onboarding-step4 v-else-if="currentState===3"
                            v-model="model.step3"
                            :createPortfolioError="createPortfolioError"
                            @errorShown="$emit('errorShown')"
                            @pageChange=" page => this.showLabels=page===0"
                            @portfolioSaved="portfolioSaved"
                            :archetype-id="model.step1.archeType"
                            :asset-distribution="assetDistribution"
                            :create-portfolio="createPortfolio"
                            :initial-capital="initialCapital"/>

      <!--      <fin-lexicon-button v-if="onboardingMode"/>-->
    </div>
  </div>
</template>

<script>
import FinOnboardingGetStarted from './GetStarted/index'
import FinOnboardingStep2 from './Step2/index'
import FinOnboardingSlider from './OnboardingSlider'
import FinOnboardingStep3 from './Step3/index'
import FinOnboardingStep4 from './Step4/index'
import AssetClassFinder from './AssetClassFinder'
import {mapGetters} from 'vuex'

export default {
  name: 'FinOnboardingProcess',
  components: {
    FinOnboardingStep4,
    FinOnboardingStep3,
    FinOnboardingSlider,
    FinOnboardingStep2,
    FinOnboardingGetStarted
  },
  props: {
    value: {},
    createPortfolio: {
      type: Function
    },
    origin: {
      type: String
    },
    createPortfolioError: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const value = Object.assign({}, this.$props.value)
    return {
      startScreen: true,
      showLabels: true,
      model: value,
      onboardingMode: true,
    }
  },
  computed: {
    ...mapGetters('archetype', ['archetypeFinder']),
    ...mapGetters('auth', ['profileArchetype']),
    currentState: {
      get() {
        return this.model?.currentState || 0
      },
      set(val) {
        this.showLabels = true
        this.$set(this.model, 'currentState', val)
      }
    },
    editablePageIndex() {
      return this.model.step2?.initialCapital > 0 ? 3 : (this.model.step1?.archeType ? 2 : 1)
    },
    initialCapital() {
      return this.model?.step2?.initialCapital || 0
    },
    assetDistribution() {
      console.log("assetDistribution", this.model.step2.assetAllocation)
      let res = AssetClassFinder.all.map((val, i) => {
        const assetAlloc = this.model.step2.assetAllocation[i]
        if (!assetAlloc) return null
        return {
          name: val,
          percentage: assetAlloc.percentage
        }
      }).filter(item => item)
      console.log("assetDistribution res", res)
      return res
    },
    navHeight() {
      let result = '66px'
      if (this.showLabels && this.$vuetify.breakpoint.lgAndUp) {
        result = '86px'
      }
      return result
    },
  },
  methods: {
    continueProcess() {
      if (this.currentState <= 0) {
        this.currentState = 1
      }
      this.startScreen = false
    },
    restart() {
      this.model = {
        currentState: 1,
        step1: {},
        step2: {},
        step3: {}
      }
      this.startScreen = false
    },
    cancel() {
      this.$confirm({
        title: 'Möchtest du den Prozess wirklich abbrechen?',
        text: 'In den nächsten Schritten führen wir dich Schritt für Schritt zu deinem ersten Portfolio. So lernst du die finCraft-Anwendung am schnellsten kennen.<br />Dein Prozess wird gespeichert und du kannst ihn jederzeit fortsetzen.',
        confirmBtn: 'Prozess abbrechen',
        textWithLexikonLink: true,
        smallButtonBreakpointXsOnly: true,
        cancelBtn: 'Prozess weiterführen'
      }).then(() => {
        this.$nextTick(() => {
          this.startScreen = true
          // its happens that the combination of v-scroll-lock and fullpage.js keeps a overflow hidden
          setTimeout(() => document.querySelector('body').style.overflow = '', 200)
        })
      }).catch(/* nothing */)
    },
    resetNextSteps2and3() {
      this.model = Object.assign({}, this.model, {
        currentState: 1,
        step2: {},
        step3: {}
      })
    },
    goToStep2() {
      this.showLabels = true
      const archeType = this.archetypeFinder.byArchetypeId(this.model.step1.archeType)
      this.model = Object.assign({}, this.model, {
        currentState: 2,
        step2: {
          assetAllocation: Object.values(archeType.assetAllocation)
        }
      })
    },
    goToStep3() {
      this.showLabels = true
      this.model = Object.assign({}, this.model, {
        currentState: 3
      })
    },
    portfolioSaved() {
      if (!("initialOnboardingFinished" in this.model)) {
        this.$set(this.model, 'initialOnboardingFinished', true)
      }
    },
  },
  beforeMount() {
    if (this.$route.fullPath.includes('finProfiler')) {
      // called via finProfiler
      // -> skip welcome
      // -> show step1
      // -> hide navigation
      this.startScreen = false
      this.onboardingMode = false
      this.model = {
        initialOnboardingFinished: true,
        currentState: 1,
        step1: {},
      }
    } else if (this.$route.fullPath.includes('finStrategist')) {
      // called via finStrategist
      // -> skip welcome
      // -> show step2
      // -> hide navigation
      this.startScreen = false
      this.onboardingMode = false
      this.model = {
        initialOnboardingFinished: true,
        currentState: 2,
        step1: {
          archeType: this.profileArchetype.id
        },
        step2: {
          assetAllocation: Object.values(this.profileArchetype.assetAllocation)
        },
        step3: {}
      }
    } else if (this.$route.params.from === 'ft') {
      this.startScreen = false
      if (!this.model) {
        this.model = {
          currentState: 1,
          step1: {},
        }
      }
    }
  },
  watch: {
    model: {
      handler(val) {
        this.$emit('input', val)
      },
      deep: true
    },
    value(val) {
      this.model = val
    }
  }
}
</script>

<style scoped>

</style>
